import { DashboardIcon } from "../../assets/images/drawerIcons/dashboardIcon";
import { SubMenuIcons } from "../../assets/images/drawerIcons/subMenuIcons";
import { SubjectIcon } from "../../assets/images/drawerIcons/subjectIcon";
import { RolesAccessIcon } from "../../assets/images/drawerIcons/rolesAccessIcon";
import { TrailIcon } from "../../assets/images/drawerIcons/trialIcon";
import { CalendarIcon } from "../../assets/images/drawerIcons/calendarIcon";
import { qrIcon } from "../../assets/images/drawerIcons/qrIcon";
import { logisticsIcon } from "../../assets/images/drawerIcons/logisticsIcon";
import { MasterDataIcon } from "../../assets/images/drawerIcons/masterDataIcon";
import { FormBuilderIcon } from "../../assets/images/drawerIcons/formBuilderIcon";
import { ManufactureIcon } from "../../assets/products-svg/ManufactureSvg";
import { QualityApprovalIcon } from "../../assets/products-svg/QualityApprovalSvg";
import { QualityControlIcon } from "../../assets/products-svg/QualityControlSvg";
import { FolderIcon } from "../../assets/images/drawerIcons/folderIcon";

const menuConfig = {
  id: "group-dashboard",
  type: "group",
  children: [
    {
      id: "dashboard",
      title: "Dashboard",
      type: "item",
      url: "/bmr/dashboard",
      icon: DashboardIcon,
      breadcrumbs: false,
      authorities: ["dashboard"],
    },
    {
      id: "feasibility-assessment",
      title: "Feasibility Assessment",
      type: "item",
      url: "",
      icon: TrailIcon,
      breadcrumbs: false,
      authorities: ["feasibility-assessment"],
      subChildren: [
        {
          id: "subjects",
          title: "Subject",
          parent: "Feasibility Assessment",
          type: "child-item",
          url: "/bmr/feasibility-assessment/subjects",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["subjects"],
        },
        {
          id: "apheresis-requests",
          title: "Apheresis Request",
          parent: "Feasibility Assessment",
          type: "child-item",
          url: "/bmr/feasibility-assessment/apheresis-requests",
          icon: SubMenuIcons,
          breadcrumbs: false,
          authorities: ["apheresis-requests"],
        },
        {
          id: "bmr-slots",
          title: "BMR Slots",
          parent: "Feasibility Assessment",
          type: "child-item",
          url: "/bmr/feasibility-assessment/bmr-slots",
          icon: SubMenuIcons,
          breadcrumbs: false,
          authorities: ["bmr-slots"],
        },
        {
          id: "payment-dashboard",
          title: "Payment Dashboard",
          parent: "Feasibility Assessment",
          type: "child-item",
          url: "/bmr/feasibility-assessment/payment-dashboard",
          icon: SubMenuIcons,
          breadcrumbs: false,
          authorities: ["payment-dashboard"],
        },
      ],
    },
    {
      id: "role-and-access-management",
      title: "Roles and Access Management",
      type: "item",
      url: "",
      icon: RolesAccessIcon,
      breadcrumbs: false,
      authorities: ["rbac"],
      subChildren: [
        {
          id: "on-board-user",
          title: "Onboard Users",
          parent: "Roles and Access Management",
          type: "child-item",
          url: "/bmr/on-board-user",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "roles-management",
          title: "Roles Management",
          type: "child-item",
          parent: "Roles and Access Management",
          url: "/bmr/roles-management",
          icon: SubMenuIcons,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
      ],
    },
    {
      id: "slot-management",
      title: "Slot Management",
      type: "item",
      url: "/bmr/slot-management",
      icon: CalendarIcon,
      breadcrumbs: false,
      authorities: ["slot-management"],
    },
    {
      id: "lsm",
      title: "QR Code Generation",
      type: "item",
      url: "/bmr/lsm",
      icon: qrIcon,
      breadcrumbs: false,
      authorities: ["qr-code-generation"],
    },
    {
      id: "logistics-management",
      title: "Logistics Management",
      type: "item",
      url: "",
      icon: logisticsIcon,
      breadcrumbs: false,
      authorities: ["logistics-management"],
      subChildren: [
        {
          id: "in-bound",
          title: "In Bound",
          parent: "Logistics Management",
          type: "child-item",
          url: "/bmr/logistics-management/in-bound",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["in-bound"],
        },

        {
          id: "out-bound",
          title: "Out Bound",
          parent: "Logistics Management",
          type: "child-item",
          url: "/bmr/logistics-management/out-bound",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["out-bound"],
        },
      ],
    },
    {
      id: "lsm-acceptance",
      title: "LSM Acceptance",
      type: "item",
      url: "/bmr/lsm-acceptance/lsm-received",
      icon: TrailIcon,
      breadcrumbs: false,
      authorities: ["lsm-acceptance"],
      subChildren: [
        {
          id: "lsm-received",
          title: "LSM Received",
          parent: "LSM Acceptance",
          type: "child-item",
          url: "/bmr/lsm-acceptance/lsm-received",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["lsm-received"],
        },

        {
          id: "approval-received",
          title: "Approved LSM",
          parent: "LSM Acceptance",
          type: "child-item",
          url: "/bmr/lsm-acceptance/approval-received",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["lsm-approved"],
        },
      ],
    },
    {
      id: "manufacturer",
      title: "Manufacturer",
      type: "item",
      url: "/bmr/manufacturer",
      icon: ManufactureIcon,
      breadcrumbs: false,
      authorities: ["product-manufacturing-process", "product-manufacturing-lead-process"],
    },
    {
      id: "quality-control",
      title: "Quality-control",
      type: "item",
      url: "/bmr/qc",
      icon: QualityControlIcon,
      breadcrumbs: false,
      authorities: ["quality-control", "quality-control-lead"]
    },
    {
      id: "quality-approval",
      title: "Quality-approval",
      type: "item",
      url: "/bmr/qa",
      icon: QualityApprovalIcon,
      breadcrumbs: false,
      authorities: ["quality-approval"],
    },
    {
      id: "form-management",
      title: "Form Management",
      type: "item",
      url: "/bmr/form-management",
      icon: FormBuilderIcon,
      breadcrumbs: false,
      authorities: ["rbac"], // @info update it accordingly later.
       subChildren: [
         {
          id: "form-templates",
          title: "Create Templates",
          type: "child-item",
          parent: "Form Management",
          url: "/bmr/form-management",
          icon: SubMenuIcons,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
         {
           id: "assigned-permission",
           title: "Approval Permission to Template",
           parent: "Form Management",
           type: "child-item",
           url: "/bmr/assigned-permission",
           icon: SubjectIcon,
           breadcrumbs: true,
           authorities: ["rbac"],
         },       
      ],
    },
    {
      id: "master",
      title: "Master",
      type: "item",
      url: "",
      icon: MasterDataIcon,
      breadcrumbs: false,
      authorities: ["rbac"],
      subChildren: [
        {
          id: "location",
          title: "Location",
          parent: "Master",
          type: "child-item",
          url: "/bmr/location",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "lsm-rejection-reason",
          title: "LSM Reject Reason",
          parent: "Master",
          type: "child-item",
          url: "/bmr/lsm-rejection-reason",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "faq",
          title: "FAQ",
          parent: "Master",
          type: "child-item",
          url: "/bmr/faq",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "leukapheresis-condition",
          title: "Leukapheresis Condition",
          parent: "Master",
          type: "child-item",
          url: "/bmr/leukapheresis-condition",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "storage-location",
          title: "Storage Location",
          parent: "Master",
          type: "child-item",
          url: "/bmr/storage-location",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "lsm-acceptance-reasons",
          title: "LSM Acceptance Reasons",
          parent: "Master",
          type: "child-item",
          url: "/bmr/lsm-acceptance-reasons",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "remanufacturing-reasons",
          title: "Remanufacturing Reasons",
          parent: "Master",
          type: "child-item",
          url: "/bmr/remanufacturing-reasons",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "delivery-partners",
          title: "Delivery Partners",
          parent: "Master",
          type: "child-item",
          url: "/bmr/delivery-partners",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "product-calculations",
          title: "Product Calculations",
          parent: "Master",
          type: "child-item",
          url: "/bmr/product-calculations",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "print-details",
          title: "Print Details",
          parent: "Master",
          type: "child-item",
          url: "/bmr/print-details",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "terminate",
          title: "Terminate",
          parent: "Master",
          type: "child-item",
          url: "/bmr/master/terminate",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "change-request",
          title: "Change Request",
          parent: "Master",
          type: "child-item",
          url: "/bmr/master/change-request",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "equipment",
          title: "Equipment",
          parent: "Master",
          type: "child-item",
          url: "/bmr/master/equipment",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "logistics-partners",
          title: "Logistics Partners",
          parent: "Master",
          type: "child-item",
          url: "/bmr/master/logistics-partners",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
      
        {
          id: "Payment",
          title: "Payment Method",
          parent: "Master",
          type: "child-item",
          url: "/bmr/master/payment",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "payment-type",
          title: "Payment Type",
          parent: "Master",
          type: "child-item",
          url: "/bmr/master/payment-type",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
        {
          id: "city",
          title: "City",
          parent: "Master",
          type: "child-item",
          url: "/bmr/master/city",
          icon: SubjectIcon,
          breadcrumbs: false,
          authorities: ["rbac"],
        },
      ],

    },
    {
      id: "download-center",
      title: "Download Center",
      type: "item",
      url: "/bmr/download-center",
      icon: FolderIcon, //@info required to update formbuilder icon
      breadcrumbs: false,
      authorities: ["download-center"],
    },
  ],
};

export default menuConfig;
